import { createRoot } from "react-dom/client";
import App from "./App";
import AppErrorBoundary from "@/components/AppErrorBoundary";
import { initAffiliateCohort } from "./lib/affiliate";
import { syncInternalTrafficFromUrl } from "./lib/internal-traffic";
import "./index.css";

// Sentry, GA4, and Skimlinks all initialise from ConsentProvider after
// the cookie consent check — see client/src/components/consent/ConsentProvider.tsx.

// Capture UTM cohort from the landing URL before the first affiliate click,
// so xcust gets the campaign label even when the visitor navigates away from
// the entry page before clicking out.
initAffiliateCohort();

// `?internal=1` / `?internal=0` marks or unmarks this browser as our own
// testing. Read before GA4 can load, which then tags every event with
// traffic_type=internal (see lib/internal-traffic.ts).
syncInternalTrafficFromUrl();

createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>,
);
